/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-05-16 20:54:38
 * @LastEditors: kevinqq 350910378@qq.com
 * @LastEditTime: 2025-03-12 19:24:55
 * @FilePath: \baishu_react_ui\src\components\dashboard\BsyDashboardCustomApp\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { Component, useState } from "react";
import "./index.css";
import BsyDialog from "../../BsyDialog";
import tipAlert from "../../../Login/BsyAlertTip/Staticize";
import { BsyUtils } from "../../../utils/Utils";
import BsyCheckBox from "../../BsyCheckBox";
import BsyMaskLayer from "../../BsyMaskLayer";
import BsySLoading from "../../BsySLoading";

export function GroupSelectPane({ list, mode = "create", onSelect, selectId }) {
  const [select, SetSelectGroup] = useState(selectId);
  const [save, SetSave] = useState(true);
  const [file, setFile] = useState(null);
  return (
    <div className="group-select-pane">
      {mode === "import" ? (
        ""
      ) : (
        <>
          <div className="select-title">
            {React.language("template.install.target.group")}
          </div>
          <div className="select-body">
            <div className="app-list">
              {list.map((it) => {
                return (
                  <div
                    key={it._id}
                    className={`app-item ${it._id === select ? "select" : ""}`}
                    onClick={() => {
                      SetSelectGroup(it._id);
                      onSelect(it._id, save, file);
                    }}
                  >
                    <i className="app-icon"></i>
                    <span className="app-name">{it.name}</span>
                    <i
                      className={`select-icon ${
                        it._id === select ? "icon-select" : ""
                      }`}
                    ></i>
                  </div>
                );
              })}
            </div>
          </div>
        </>
      )}

      {mode === "import" ? (
        <>
          <div style={{ margin: "12px 0" }}>
            <label className="upload-btn" htmlFor="file">
              <i className="icon-widget-image icon-bby-anzhuanbaoshangchuang"></i>
              <span className="title">
                {file
                  ? React.language("upload.redo")
                  : React.language("Upload.installation.package")}
              </span>
              {file ? (
                ""
              ) : (
                <span className="subtitle">(.bsys和.bsy后缀的文件)</span>
              )}
            </label>
            <input
              type="file"
              id="file"
              name="file"
              className="upload-btn-input"
              accept=".bsys,.bsy"
              style={{ display: "none" }}
              onChange={(event) => {
                setFile(event.target.files[0]);
                onSelect(select, save, event.target.files[0]);
              }}
            />
            {file ? (
              <span className="file-name">
                {React.language("selected.it", { name: file.name })}
              </span>
            ) : (
              ""
            )}
          </div>
          <BsyCheckBox
            text={React.language("import.package.group.tip")}
            value={save}
            onStopEdit={(e) => {
              SetSave(e);
              onSelect(select, e, file);
            }}
          />
        </>
      ) : (
        ""
      )}
    </div>
  );
}

export class CreateApp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      apps: props.apps || [],
    };
  }

  createBlankApp = () => {
    const { apps } = this.state;
    let select = apps[0]._id;
    BsyDialog({
      title: React.language("template.install.toGroup"),
      width: 450,
      height: 390,
      noFooter: false,
      okText: React.language("ok"),
      cancelText: React.language("cancel"),
      onContentCreate: (ref) => {
        return (
          <GroupSelectPane
            list={apps}
            selectId={select}
            onSelect={(id, save, file) => {
              select = id;
            }}
          />
        );
      },
      onOk: () => {
        if (!select) {
          tipAlert({
            type: "warning",
            msg:
              React.language("dash.data.manage.selectPlaceholder") +
              React.language("group"),
          });
          return false;
        }
        this._installApp({ mode: "blank", groupid: select });
      },
    });
  };

  selectGroup = (data, cb) => {
    const { apps } = this.state;
    let select = apps[0]._id;
    BsyDialog({
      title: React.language("template.install.toGroup"),
      width: 450,
      height: 390,
      noFooter: false,
      okText: React.language("ok"),
      cancelText: React.language("cancel"),
      onContentCreate: (ref) => {
        return (
          <GroupSelectPane
            list={apps}
            selectId={select}
            onSelect={(id, save, file) => {
              select = id;
            }}
          />
        );
      },
      onOk: () => {
        if (!select) {
          tipAlert({
            type: "warning",
            msg:
              React.language("dash.data.manage.selectPlaceholder") +
              React.language("group"),
          });
          return false;
        }
        cb && cb(select);
      },
      onCancel: () => {
        this.layerRef && this.layerRef.close();
      }
    });
  };

  importApp = (data) => {
    const { apps } = this.state;
    let formdata = data || new FormData();
    this.imprtExtName = "";
    let select = apps[0]._id;
    BsyDialog({
      title: React.language("import.package.group"),
      width: 450,
      height: data ? 390 : 250,
      noFooter: false,
      okText: React.language("ok"),
      cancelText: React.language("cancel"),
      onContentCreate: (ref) => {
        return (
          <GroupSelectPane
            mode={data ? "" : "import"}
            list={apps}
            selectId={select}
            onSelect={(id, save, file) => {
              formdata = new FormData();
              if (file) {
                formdata.set("file", file);
                this.imprtExtName = file.name.split(".").pop();
              }

              formdata.set("sampledata", save);
              if (this.imprtExtName !== "bsys") {
                if (id) {
                  formdata.set("groupid", id);
                }
              }
            }}
          />
        );
      },
      onOk: () => {
        if (!formdata.get("file")) {
          tipAlert({
            type: "warning",
            msg:
              React.language("dash.data.manage.selectPlaceholder") +
              React.language("file"),
          });
          return false;
        }

        this.layerRef = null;
        BsyMaskLayer({
          customCls: "sloading",
          onContentCreate: (ref) => {
            this.layerRef = ref;
            return (
              <div>
                <BsySLoading />
              </div>
            );
          },
        });

        if (this.imprtExtName === "bsys") {
          this.importBsys(formdata);
        } else {
          this.selectGroup(formdata, (groupid) => {
            formdata.append("groupid", groupid);
            this.importPackage(formdata);
          });
        }
      },
    });
  };

  importBsys = (formdata) => {
    React.axios("/dashboard/check_install_tip", formdata)
      .then((res) => {
        const { data } = res;
        const { install_tip, needGroup } = data;
        if (install_tip) {
          BsyDialog({
            title: React.language("installation.notes"),
            height: 577,
            width: 956,
            okText: React.language("app.install"),
            cancelText: React.language("cancel"),
            onContentCreate: () => {
              return (
                <div
                  style={{
                    whiteSpace: "pre-wrap",
                    padding: 20,
                    height: "100%",
                    overflow: "auto",
                    margin: "0 20px",
                    background: "#efefef",
                  }}
                >
                  {install_tip}
                </div>
              );
            },
            onOk: () => {
              if (needGroup) {
                this.selectGroup(formdata, (groupid) => {
                  formdata.append("groupid", groupid);
                  this.importPackage(formdata);
                });
              } else {
                this.importPackage(formdata);
              }
            },
          });
        } else {
          if (needGroup) {
            this.selectGroup(formdata, (groupid) => {
              formdata.append("groupid", groupid);
              this.importPackage(formdata);
            });
          } else {
            this.importPackage(formdata);
          }
        }
      })
      .catch((res) => {
        this.layerRef && this.layerRef.close();
        if (res.state === 400) {
          tipAlert({
            type: "error",
            msg: res.data.msg,
          });
        }
      });
  };

  importPackage = async (data) => {
    if (this.imprtExtName === "bsys") {
      let res = await React.axios("/dashboard/app_group/list");
      let appNewList1 = [];
      res.data.items.map((item) => {
        item.apps.map((app) => {
          appNewList1.push(app._id);
          return null;
        });
        return null;
      });

      try {
        let res2 = await React.axios("/dashboard/importbby_batch", data);
        if (res2.data.code === 200) {
          let res3 = await React.axios("/dashboard/app_group/list");
          let appNewList2 = [];

          res3.data.items.map((item) => {
            item.apps.map((app) => {
              appNewList2.push(app._id);
              return null;
            });
            return null;
          });

          let newList = appNewList2.filter(
            (item) => !appNewList1.includes(item)
          );
          const tmp = BsyUtils.Store.get("appNewList") || [];
          BsyUtils.Store.set("appNewList", [...tmp, ...newList]);
          BsyUtils.redirectTo(window.rootDirectroy + "/");
        } else {
          BsyUtils.showAjaxTip(res2.data);
        }
        this.layerRef && this.layerRef.close();
      } catch (error) {
        this.layerRef && this.layerRef.close();
        console.error("捕获到错误:", error);
      }
    } else {
      React.axios("/dashboard/importbby", data)
        .then((res) => {
          this.layerRef && this.layerRef.close();
          if (res.data.success === 1) {
            BsyUtils.redirectTo(
              window.rootDirectroy + "/team/app/" + res.data.data.strappid
            );
          } else {
            BsyUtils.showAjaxTip(res.data);
          }
        })
        .catch((res) => {
          this.layerRef && this.layerRef.close();
          if (res.state === 400) {
            tipAlert({
              type: "error",
              msg: res.data.msg,
            });
          }
        });
    }
  };

  _installApp = (data) => {
    React.axios("/bbymember/tpl_install", {
      ...data,
    })
      .then((res) => {
        this.layerRef && this.layerRef.close();
        if (res.data.code === 200) {
          BsyUtils.redirectTo("/team/app/" + res.data.data.strappid);
        } else {
          tipAlert({
            type: "warning",
            msg: res.data.msg,
          });
        }
      })
      .catch((res) => {
        this.layerRef && this.layerRef.close();
        if (res.state === 400) {
          tipAlert({
            type: "error",
            msg: res.data.msg,
          });
        }
      });
  };

  render() {
    return (
      <div className="dashboard-create-app-pane-box">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div className="dashboard-create-app-pane-box-title">
            <span>{this.props.title}</span>
          </div>
          <div className={"dashboard-create-app-pane"}>
            <div className="pane-item pane-left" onClick={this.createBlankApp}>
              <div className="pane-center-bg">
                <img src={"/template/resource/images/create-left.png"} alt="" />
                <div className="title">
                  <div className="title-1">
                    {React.language("webhook.create.app.blank.application")}
                  </div>
                  <div className="title-2">
                    {React.language("webhook.create.app.office.apps")}
                  </div>
                </div>
              </div>
              <img
                className="pane-d"
                src={"/template/resource/images/img-d-left.png"}
                alt=""
              />
            </div>
            <div
              className="pane-item pane-center"
              onClick={() => {
                window.location.href = "/bsymember/appstore?to=create";
              }}
            >
              <div className="pane-center-bg">
                <img
                  src={"/template/resource/images/create-center.png"}
                  alt=""
                />
                <div className="title">
                  <div className="title-1">
                    {React.language(
                      "webhook.create.app.select.application.template"
                    )}
                  </div>
                  <div className="title-2">
                    {React.language(
                      "webhook.create.applications.from.template.center"
                    )}
                  </div>
                </div>
              </div>
              <img
                className="pane-d"
                src={"/template/resource/images/img-d-center.png"}
                alt=""
              />
            </div>
            <div
              className="pane-item pane-right"
              onClick={() => {
                this.importApp();
              }}
            >
              <div className="pane-center-bg">
                <img
                  src={"/template/resource/images/create-right.png"}
                  alt=""
                />
                <div className="title">
                  <div className="title-1">
                    {React.language(
                      "webhook.create.app.importing.installation.package"
                    )}
                  </div>
                  <div className="title-2">
                    {React.language(
                      "webhook.create.app.import.application.installation.package.system"
                    )}
                  </div>
                </div>
              </div>
              <img
                className="pane-d"
                src={"/template/resource/images/img-d-right.png"}
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
